// Zajedničko formatiranje datuma i vremena za prikaz karata i polazaka.
// Ulaz može biti ISO string, Date-parsabilan string ili već formatiran "HH:mm[:ss]".
// Neparsabilan ulaz se vraća netaknut — bolje sirov prikaz nego prazno polje.

export function fmtDate(raw, fallback = "") {
    if (!raw) return fallback;
    try {
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;
    } catch {
        return raw;
    }
}

export function fmtTime(raw, fallback = "") {
    if (!raw) return fallback;
    if (typeof raw === "string" && raw.match(/^\d{2}:\d{2}/)) return raw.substring(0, 5);
    try {
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    } catch {
        return raw;
    }
}
